// init.ts used to initialize Document domain components on startup.

import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { DocumentSharedItemProvider } from "./Services/Portal/DocumentSharedItemProvider";

sharedItemProviderFactory.registerProvider(PortalLinkedItemType.Document, new DocumentSharedItemProvider());
